import React from 'react';
import "./LoadSpinnerOverlay.scss";

export function LoadSpinnerOverlay(props: {

}) {



    return (
        <div className="load-spinner-overlay modal modal-open" aria-modal="true">
            <div className="contents">
                <div className="spinner-grow text-light" role="status" >
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    );
}
